<template>
    <div>
    <div class="column">
        <div class="heading" style="margin:0"><span><b>Income Metrics</b></span></div>
        <div class="card card-height">
      <div class="frm-group">
          <div class="col-60">
        <label for="originationRevenue"> Origination Revenue </label>
        </div>
        <div class="col-30">
        <label type="Text" class="labelright">{{calcOriginationRevenue}}</label>
        </div>
      </div>
      <div class="frm-group">
        <div class="col-60">
        <label for="originationReserve"> Origination Reserve </label>
        </div>
        <div class="col-30">
        <label type="Text" class="labelright">80.12</label>
        </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="originationIncome"> Origination Income </label>
        </div>
        <div class="col-30">
        <label type="Text" class="labelright">{{calcOriginationIncome}}</label>
        </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="annuityRevenueMonthly"> Annuity Revenue - Monthly </label>
        </div>
        <div class="col-30">
        <label type="Text" class="labelright">{{calcAnnuityRevenueMonthly}}</label>
        </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="annuityReserveMonthly"> Annuity Reserve - Monthly </label>
          </div>
          <div class="col-30">
        <label type="Text" class="labelright">36.90</label>
          </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="annuityIncomeMonthly"> Annuity Income - Monthly </label>
          </div>
          <div class="col-30">
        <label type="Text" class="labelright">{{calcAnnuityIncomeMonthly}}</label>
          </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="annuityRevenueLifeOfLease"> Annuity Revenue- Life Of Lease </label>
          </div>
          <div class="col-30">
        <label type="Text" class="labelright">{{calcAnnuityRevenueLifeofLease}}</label>
          </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="annuityReserveLifeOfLease"> Annuity Reserve- Life Of Lease </label>
          </div>
          <div class="col-30">
        <label type="Text" class="labelright">{{calcAnnuityReserveLifeofLease}}</label>
          </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="annuityIncomeLifeOfLease"> Annuity Income- Life Of Lease </label>
          </div>
          <div class="col-30">
        <label type="Text" class="labelright">{{calcAnnuityIncomeLifeofLease}}</label>
          </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="totalRevenueLifeOfLease"> Total Revenue- Life Of Lease </label>
          </div>
          <div class="col-30">
        <label type="Text" class="labelright">{{calcTotalRevenueLifeofLease}}</label>
          </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="totalReserveLifeOfLease"> Total Reserve- Life Of Lease  </label>
          </div>
          <div class="col-30">
        <label type="Text" class="labelright">{{calcTotalReserveLifeofLease}}</label>
          </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="totalIncomeLifeOfLease"> Total Income- Life Of Lease </label>
          </div>
          <div class="col-30">
        <label type="Text" class="labelright">{{calcTotalIncomeLifeofLease}}</label>
          </div>
      </div>
</div></div>
<div class="column1">
        <div class="heading marginzero"><span><b>Amortization Table</b></span></div>
        <div class="card card-height amorttable">

            <table id='myQuotesTable' class="table-top table-month-table">
     <tr >
       <th class="table-month-header" >Period</th>
      <th class="table-month-header" >Value</th>
      <th class="table-month-header" >Amort (Est).</th>
      <th class="table-month-header" >Equity</th>
      <th class="table-month-header" >% Equity</th>
   </tr>
   <tr class="table-month-row" v-for="(amort,index) in amortization.estimations" :key="index" >
      <td class="table-month-td" v-if="index==0"> @Inception</td>
      <td class="table-month-td" v-else> @Month {{displayMonth(index)}}</td>
      <td class="table-month-td" > </td>
      <td class="table-month-td" >{{amort.value}} </td>
      <td class="table-month-td" > </td>
      <td class="table-month-td" > </td>
      </tr>
      <tr class="table-month-row">
      <td class="table-month-td">Wtd Average </td>
      <td class="table-month-td"> </td>
      <td class="table-month-td"> </td>
      <td class="table-month-td"> </td>
      <td class="table-month-td"> </td>

      </tr>
            </table>
    </div></div>
    <div class="column1">
        <div class="heading" style="margin:0"><span><b>Tax Metrics</b></span></div>
        <div class="card card-metrics">
            <div class="frm-group">
                <div class="col-40">
                    <label for="taxDueOnCashCapRed"> Tax Due on Cash Cap Red. </label>
                </div>
                <div class="col-30">
                    <label type="Text" class="labelright">{{calcTaxDueOnCashCapRed}}</label>
                </div>
            </div>
            <div class="frm-group">
                <div class="col-40">
                    <label for="taxDueOnPmtsCapCost"> Tax Due on Pmts/Cap Cost </label>
                </div>
                <div class="col-30">
                    <label type="Text" class="labelright">{{calcTaxDueOnPaymentOrCapcost}}</label>
                </div>
            </div>
            <div class="frm-group">
                <div class="col-40">
                    <label for="taxOnTrade"> Tax on Trade </label>
                </div>
                <div class="col-30">
                    <label type="Text" class="labelright">{{calcTaxOnTrade}}</label>
                </div>
            </div>

        </div>
    </div>
    <div class="column">
        <div class="heading" style="margin:0"><span><b>Loan Metrics</b></span></div>
        <div class="card card-metrics card-loan">
      <div class="frm-group">
          <div class="col-60">
        <label for="totalIncomeLifeOfLease">First year loan payment</label>
          </div>
          <div class="col-30">
        <label type="Text" class="labelright"></label>
          </div>
      </div>
      <div class="frm-group">
          <div class="col-60">
        <label for="totalIncomeLifeOfLease">Base Loan Payment(Estimate) </label>
          </div>
          <div class="col-30">
        <label type="Text" class="labelright">{{calcLoanPaymentEstimate}}</label>
          </div>
      </div>
    </div></div>
    <div class="column1">
        <div class="heading" style="margin:0"><span><b>Reg M Threshold Check</b></span></div>
        <div class="card card-metrics">
            <div class="frm-group">
                <div class="col-40">
                    <label for="taxDueOnCashCapRed"> Reg M Threshold </label>
                </div>
                <div class="col-30">
                    <label type="Text" class="labelright"></label>
                </div>
            </div>
            <div class="frm-group">
                <div class="col-40">
                    <label for="taxDueOnPmtsCapCost"> Total Payments </label>
                </div>
                <div class="col-30">
                    <label type="Text" class="labelright"></label>
                </div>
            </div>
            <div class="frm-group">
                <div class="col-40">
                    <label for="taxOnTrade"> Above Threshold </label>
                </div>
                <div class="col-30">
                    <label type="Text" class="labelright">  </label>
                </div>
            </div>

        </div>
    </div>

<div id="marginright">
    <input type="button" id="tabbutton" @click="quoteobject.quote.tabIndex--" value="Back">
</div>
    </div>
</template>
<script>
import amortization from '../js/http-amortization'
import { bus } from '../main'
export default {
  props: ['quoteobject'],
  created () {
    bus.$on('i-got-clicked', data => {
      console.log(data)
      // You can then call your method attached to this component here
      this.amortEst()
    })
  },

  data () {
    return {
      amortization: [],
      loanDate: '06/25/2019',
      loanamt: 10.10,
      downpayment: 100,
      interest: 0.09,
      pmtStartDate: '07/05/2019',
      numofpayments: 36
    }
  },
  methods: {
    displayMonth (row) {
      try {
        if ((Math.floor((this.quoteobject.quote.de_remaining_payments - 2) / (row * 12)) > 0)) { return row * 12 } else { return this.quoteobject.quote.de_remaining_payments }
      } catch (e) {
        return 1
      }
    },
    amortEst () {
      amortization.get('?', {
        params: {
          loanDate: this.loanDate,
          loanAmt: this.loanamt,
          downPayment: this.downpayment,
          interest: this.interest,
          pmtStartDate: this.pmtStartDate,
          numOfPayments: this.numofpayments
        }
      }).then(response => {
        this.amortization = response.data
        console.log(JSON.stringify(this.amortization.estimations[0]))
      })
    }
  },
  computed: {
    paymentRows () {
      if (isNaN(this.quoteobject.quote.de_remaining_payments) > 0) {
        return 1
      }
      if (Number(this.quoteobject.quote.de_remaining_payments) > 72) {
        return 1
      }

      return Math.ceil(this.quoteobject.quote.de_remaining_payments / 12) + 1
    },
    calcOriginationRevenue () {
      if (this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment != '' && this.quoteobject.quote.lm_advance_rental_payments != '' && this.quoteobject.quote.ld_acquisition_fee != 0) {
        this.quoteobject.quote.lm_origination_revenue = (this.quoteobject.quote.ld_final_monthly_lease_payment * this.quoteobject.lm_advance_rental_payments) + parseInt(this.quoteobject.quote.ld_acquisition_fee)
        return this.quoteobject.quote.lm_origination_revenue
      } else return this.quoteobject.quote.lm_origination_revenue
    },
    calcOriginationIncome () {
      if (this.quoteobject.quote.lm_origination_revenue != '' && this.quoteobject.quote.lm_origination_reserve != '') {
        this.quoteobject.quote.lm_origination_income = this.quoteobject.quote.lm_origination_revenue - this.quoteobject.quote.lm_origination_reserve
        return this.quoteobject.quote.lm_origination_income
      } else return this.quoteobject.quote.lm_origination_income
    },
    calcAnnuityRevenueMonthly () {
      if (this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment != '' && this.quoteobject.quote.lm_loan_payment_estimate != '') {
        this.quoteobject.quote.lm_annuity_revenue_monthly = this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment - this.quoteobject.quote.lm_loan_payment_estimate
        return this.quoteobject.quote.lm_annuity_revenue_monthly
      } else return 'Key Inputs'
    },
    calcAnnuityIncomeMonthly () {
      if (this.quoteobject.quote.lm_annuity_revenue_monthly != '' && this.quoteobject.quote.lm_annuity_reserve_monthly != '') {
        this.quoteobject.quote.lm_annuity_income_monthly = this.quoteobject.quote.lm_annuity_revenue_monthly - this.quoteobject.quote.lm_annuity_reserve_monthly
        return this.quoteobject.quote.lm_annuity_income_monthly
      } else return 'Key Inputs'
    },
    calcAnnuityRevenueLifeofLease () {
      if (this.quoteobject.quote.lm_annuity_revenue_monthly != '' && this.quoteobject.quote.de_remaining_payments != '') {
        this.quoteobject.quote.lm_annuity_revenue_life_of_lease = this.quoteobject.quote.lm_annuity_revenue_monthly * this.quoteobject.quote.de_remaining_payments
        return this.quoteobject.quote.lm_annuity_revenue_life_of_lease
      } else return 'Key Inputs'
    },
    calcAnnuityReserveLifeofLease () {
      if (this.quoteobject.quote.lm_annuity_reserve_monthly != '' && this.quoteobject.quote.de_remaining_payments != '') {
        this.quoteobject.quote.lm_annuity_reserve_life_of_lease = this.quoteobject.quote.lm_annuity_reserve_monthly * this.quoteobject.quote.de_remaining_payments
        return this.quoteobject.quote.lm_annuity_reserve_life_of_lease
      } else return 'Key Inputs'
    },
    calcAnnuityIncomeLifeofLease () {
      if (this.quoteobject.quote.lm_annuity_revenue_life_of_lease != '' && this.quoteobject.quote.lm_annuity_reserve_life_of_lease != '') {
        this.quoteobject.quote.lm_annuity_income_life_of_lease = this.quoteobject.quote.lm_annuity_revenue_life_of_lease - this.quoteobject.quote.lm_annuity_reserve_life_of_lease
        return this.quoteobject.quote.lm_annuity_income_life_of_lease
      } else return 'Key Inputs'
    },
    calcTotalRevenueLifeofLease () {
      if (this.quoteobject.quote.lm_origination_revenue != '' && this.quoteobject.quote.lm_annuity_revenue_life_of_lease != '') {
        this.quoteobject.quote.lm_total_revenue_life_of_lease = parseInt(this.quoteobject.quote.lm_origination_revenue) + parseInt(this.quoteobject.quote.lm_annuity_revenue_life_of_lease)
        return this.quoteobject.quote.lm_total_revenue_life_of_lease
      } else return 'Key Inputs'
    },
    calcTotalReserveLifeofLease () {
      if (this.quoteobject.quote.lm_origination_reserve != '' && this.quoteobject.quote.lm_annuity_reserve_life_of_lease != '') {
        this.quoteobject.quote.lm_total_reserve_life_of_lease = parseInt(this.quoteobject.quote.lm_origination_reserve) + parseInt(this.quoteobject.quote.lm_annuity_reserve_life_of_lease)
        return this.quoteobject.quote.lm_total_reserve_life_of_lease
      } else return 'Key Inputs'
    },
    calcTotalIncomeLifeofLease () {
      if (this.quoteobject.quote.lm_origination_income != '' && this.quoteobject.quote.lm_annuity_income_life_of_lease != '') {
        this.quoteobject.quote.lm_total_income_life_of_lease = parseInt(this.quoteobject.quote.lm_origination_income) + parseInt(this.quoteobject.quote.lm_annuity_income_life_of_lease)
        return this.quoteobject.quote.lm_total_income_life_of_lease
      } else return 'Key Inputs'
    },
    calcTaxDueOnCashCapRed () {
      if (this.quoteobject.quote.state_fips_c == 'AZ' || this.quoteobject.quote.state_fips_c == 'CA' || this.quoteobject.quote.state_fips_c == 'CO' ||
      this.quoteobject.quote.state_fips_c == 'CT' || this.quoteobject.quote.state_fips_c == 'DE' || this.quoteobject.quote.state_fips_c == 'FL' ||
       this.quoteobject.quote.state_fips_c == 'IN' || this.quoteobject.quote.state_fips_c == 'MA' || this.quoteobject.quote.state_fips_c == 'MI' ||
       this.quoteobject.quote.state_fips_c == 'NC' || this.quoteobject.quote.state_fips_c == 'NH' || this.quoteobject.quote.state_fips_c == 'NV' ||
       this.quoteobject.quote.state_fips_c == 'TN' || this.quoteobject.quote.state_fips_c == 'UT' || this.quoteobject.quote.state_fips_c == 'PA' ||
       this.quoteobject.quote.state_fips_c == 'WA') {
        this.quoteobject.quote.lm_tax_due_on_cash_cap_red = this.quoteobject.quote.vd_cash_cap_reduction * ((this.quoteobject.quote.de_state_tax_rate_pct) / 100 + (this.quoteobject.quote.de_county_tax_rate_pct) / 100 + (this.quoteobject.quote.de_zip_tax_rate_pct) / 100)
        return this.quoteobject.quote.lm_tax_due_on_cash_cap_red.toFixed(2)
      }
    },
    calcTaxDueOnPaymentOrCapcost () {
      if (this.quoteobject.quote.state_fips_c == 'NY' || this.quoteobject.quote.state_fips_c == 'OH') {
        this.quoteobject.quote.lm_tax_due_on_pmts_cap_cost = this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment * ((this.quoteobject.quote.de_state_tax_rate_pct) / 100 + (this.quoteobject.quote.de_county_tax_rate_pct) / 100 + (this.quoteobject.quote.de_zip_tax_rate_pct) / 100) * this.quoteobject.quote.lm_total_monthly_payment
        return this.quoteobject.quote.lm_tax_due_on_pmts_cap_cost.toFixed(2)
      } else if (this.quoteobject.quote.state_fips_c == 'GA' || this.quoteobject.quote.state_fips_c == 'IL' || this.quoteobject.quote.state_fips_c == 'MD' ||
      this.quoteobject.quote.state_fips_c == 'NJ' || this.quoteobject.quote.state_fips_c == 'TX' || this.quoteobject.quote.state_fips_c == 'VA' || this.quoteobject.quote.state_fips_c == 'OK') {
        this.quoteobject.quote.lm_tax_due_on_pmts_cap_cost = this.quoteobject.quote.vd_lease_cap_cost * ((this.quoteobject.quote.de_state_tax_rate_pct) / 100 + (this.quoteobject.quote.de_county_tax_rate_pct) / 100 + (this.quoteobject.quote.de_zip_tax_rate_pct) / 100)
        return this.quoteobject.quote.lm_tax_due_on_pmts_cap_cost.toFixed(2)
      } else if (this.quoteobject.quote.state_fips_c == 'SC') {
        this.quoteobject.quote.lm_tax_due_on_pmts_cap_cost = 300
        return this.quoteobject.quote.lm_tax_due_on_pmts_cap_cost
      }
    },
    calcLoanPaymentEstimate () {
      if (this.quoteobject.quote.de_loan_funding_cost != '' && this.quoteobject.quote.vd_llp_final_residual > 0 &&
          this.quoteobject.quote.de_remaining_payments > 0 && this.quoteobject.quote.lm_loan_amount != '') {
        var a = (this.quoteobject.quote.de_loan_funding_cost / 100)
        var b = a / 12 + 1
        var c = this.quoteobject.quote.vd_llp_final_residual
        var npv = c / b// fv
        var loanfundingcost = a / 12// rate
        var remainingpayments = this.quoteobject.quote.de_remaining_payments// npr
        var loanamount = -this.quoteobject.quote.lm_loan_amount// pv
        var x = Math.pow(1 + loanfundingcost, remainingpayments)

        var pmt_value = -((loanfundingcost * (npv + x * loanamount)) / (-1 + x))
        return pmt_value.toFixed(2)
      } else return 'key Inputs'
    },
    calcTaxOnTrade () {
      if (this.quoteobject.quote.de_is_trade_tax_exempt == 'N') {
        this.quoteobject.quote.lm_tax_on_trade = this.quoteobject.quote.vd_trade_credit * ((this.quoteobject.quote.de_state_tax_rate_pct) / 100 + (this.quoteobject.quote.de_county_tax_rate_pct) / 100 + (this.quoteobject.quote.de_zip_tax_rate_pct) / 100)
        return this.quoteobject.quote.lm_tax_on_trade.toFixed(2)
      }
    }

  }

}

</script>
<style scoped>
 .frm-group {
    /** display: -webkit-flex;  **/
    display: flex;
    flex-flow: row;
    align-items: left;
    width:100%;
}
.frm-group label {
    text-align: left;
    vertical-align: bottom;
    font-size: 12px;
    margin: 8px 15px 0px 10px;
    display:block;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.frm-group input {
    width: 100%;
    padding: 6px;
    border: 1px solid #ddd;
    border-radius: 5px;
    resize: vertical;
    margin: 5px 0px 0px 0px;
}

.column {
  float: left;
  width: 40%;
  padding: 1px;
}
.column1 {
  float: left;
  width: 60%;
  padding: 1px;
}

.table-month-header {
 background: #ddd;
 color: black;
   text-align: center;
 font-weight: bold;
border:1px solid black;
 text-align: center;
 font-size: 12px;
 font-family: Verdana, Geneva, Tahoma, sans-serif;
 }

 .card-height{
   height: 320px;
   padding-top:0px
 }
 .amorttable{
   height:180px
 }
 .card-metrics{
   height: 100px;
 }
 .card-loan{
   padding-top: 5%
 }
 .table-top{
   margin-top:3px
 }
 .labelright{
    float:right
}
#tabbutton{
    float:right;
    color: white;
    padding: 6px 20px;
    background-color: dodgerblue;
    border: 1px solid #ddd;
    margin: 10px 0px 0px 0px;
}
#marginright{
    margin-right: 10%
}
@media (max-width: 1100px){
  .column{
    width: 100%;
  }
  .column1{
    width:100%
  }
}
</style>
